/**
 * Pre-screening upsell panel (design §4, right side of the header card).
 * The button fires the callback the page wires: DetailPageController opens the
 * ProceedToFullScreenDialog when an upgrade is available (completed pre-screen
 * report + org entitled — `data.fullScreenUpgrade`), else an informational toast
 * (TT-BILL-200). Copy is design-exact.
 */
import { ArrowRight, Crown } from 'lucide-react'

export function UpsellBanner({
	onProceedToFullScreen,
}: {
	onProceedToFullScreen?: () => void
}) {
	return (
		<div className="flex flex-wrap items-center gap-5 rounded-2xl bg-[#f4f6f6] p-5">
			<span className="flex size-14 shrink-0 items-center justify-center rounded-full bg-[#FFF6EA] text-[#F59F0A]">
				<Crown className="size-6" />
			</span>
			<div className="min-w-0 flex-1 basis-52">
				<p className="text-[15px] leading-snug text-gray-500">
					Run A Full Screen On This Applicant & Unlock The TrueTenant Score,
					Credit Report & Risk Flags
				</p>
			</div>
			<button
				type="button"
				onClick={onProceedToFullScreen}
				className="flex shrink-0 cursor-pointer items-center gap-2 rounded-full bg-[#32302F] px-7 py-3.5 text-[15px] font-bold text-white transition-colors hover:bg-[#1a1918]"
			>
				Get Full Report
				<ArrowRight className="size-4" />
			</button>
		</div>
	)
}
